/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NFSPermission,
    NFSPermissionFromJSON,
    NFSPermissionFromJSONTyped,
    NFSPermissionToJSON,
    ProductionReference,
    ProductionReferenceFromJSON,
    ProductionReferenceFromJSONTyped,
    ProductionReferenceToJSON,
    VolumeReference,
    VolumeReferenceFromJSON,
    VolumeReferenceFromJSONTyped,
    VolumeReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspaceDetailPartialUpdate
 */
export interface WorkspaceDetailPartialUpdate {
    /**
     * 
     * @type {ProductionReference}
     * @memberof WorkspaceDetailPartialUpdate
     */
    production?: ProductionReference;
    /**
     * 
     * @type {VolumeReference}
     * @memberof WorkspaceDetailPartialUpdate
     */
    volume?: VolumeReference;
    /**
     * 
     * @type {Array<NFSPermission>}
     * @memberof WorkspaceDetailPartialUpdate
     */
    sharingNfsPermissions?: Array<NFSPermission>;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceDetailPartialUpdate
     */
    quotaSizeHard?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceDetailPartialUpdate
     */
    quotaSizeSoft?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    longDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    isTemplate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    macProtocol?: WorkspaceDetailPartialUpdateMacProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    winProtocol?: WorkspaceDetailPartialUpdateWinProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    winDrive?: WorkspaceDetailPartialUpdateWinDriveEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    linuxProtocol?: WorkspaceDetailPartialUpdateLinuxProtocolEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    linuxMountpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    shareName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    shareNfs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    shareAfp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    sharingHidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    sharingRequireLogin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    sharingReadOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    sharingAllowExecute?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    enableQuota?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    affinity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    emulateAvid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    emulateCapture?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    emulatePreopen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    emulateNtfsStreams?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    emulateRecycleBin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    emulateFruit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    smbExtraConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    afpExtraConfig?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    recycleBinExclude?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    isExternal?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    externalMacUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    externalWinUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkspaceDetailPartialUpdate
     */
    externalLinuxUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    allowSymlinks?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceDetailPartialUpdate
     */
    rwPermissionPriority?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceDetailPartialUpdate
     */
    template?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum WorkspaceDetailPartialUpdateMacProtocolEnum {
    Smb = 'smb',
    Afp = 'afp',
    Nfs = 'nfs',
    Omfs = 'omfs'
}/**
* @export
* @enum {string}
*/
export enum WorkspaceDetailPartialUpdateWinProtocolEnum {
    Disk = 'disk',
    Unc = 'unc'
}/**
* @export
* @enum {string}
*/
export enum WorkspaceDetailPartialUpdateWinDriveEnum {
    A = 'a',
    B = 'b',
    C = 'c',
    D = 'd',
    E = 'e',
    F = 'f',
    G = 'g',
    H = 'h',
    I = 'i',
    J = 'j',
    K = 'k',
    L = 'l',
    M = 'm',
    N = 'n',
    O = 'o',
    P = 'p',
    Q = 'q',
    R = 'r',
    S = 's',
    T = 't',
    U = 'u',
    V = 'v',
    W = 'w',
    X = 'x',
    Y = 'y',
    Z = 'z'
}/**
* @export
* @enum {string}
*/
export enum WorkspaceDetailPartialUpdateLinuxProtocolEnum {
    Smb = 'smb',
    Nfs = 'nfs'
}

export function WorkspaceDetailPartialUpdateFromJSON(json: any): WorkspaceDetailPartialUpdate {
    return WorkspaceDetailPartialUpdateFromJSONTyped(json, false);
}

export function WorkspaceDetailPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceDetailPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'production': !exists(json, 'production') ? undefined : ProductionReferenceFromJSON(json['production']),
        'volume': !exists(json, 'volume') ? undefined : VolumeReferenceFromJSON(json['volume']),
        'sharingNfsPermissions': !exists(json, 'sharing_nfs_permissions') ? undefined : ((json['sharing_nfs_permissions'] as Array<any>).map(NFSPermissionFromJSON)),
        'quotaSizeHard': !exists(json, 'quota_size_hard') ? undefined : json['quota_size_hard'],
        'quotaSizeSoft': !exists(json, 'quota_size_soft') ? undefined : json['quota_size_soft'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'isTemplate': !exists(json, 'is_template') ? undefined : json['is_template'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'macProtocol': !exists(json, 'mac_protocol') ? undefined : json['mac_protocol'],
        'winProtocol': !exists(json, 'win_protocol') ? undefined : json['win_protocol'],
        'winDrive': !exists(json, 'win_drive') ? undefined : json['win_drive'],
        'linuxProtocol': !exists(json, 'linux_protocol') ? undefined : json['linux_protocol'],
        'linuxMountpoint': !exists(json, 'linux_mountpoint') ? undefined : json['linux_mountpoint'],
        'shareName': !exists(json, 'share_name') ? undefined : json['share_name'],
        'shareNfs': !exists(json, 'share_nfs') ? undefined : json['share_nfs'],
        'shareAfp': !exists(json, 'share_afp') ? undefined : json['share_afp'],
        'sharingHidden': !exists(json, 'sharing_hidden') ? undefined : json['sharing_hidden'],
        'sharingRequireLogin': !exists(json, 'sharing_require_login') ? undefined : json['sharing_require_login'],
        'sharingReadOnly': !exists(json, 'sharing_read_only') ? undefined : json['sharing_read_only'],
        'sharingAllowExecute': !exists(json, 'sharing_allow_execute') ? undefined : json['sharing_allow_execute'],
        'enableQuota': !exists(json, 'enable_quota') ? undefined : json['enable_quota'],
        'affinity': !exists(json, 'affinity') ? undefined : json['affinity'],
        'emulateAvid': !exists(json, 'emulate_avid') ? undefined : json['emulate_avid'],
        'emulateCapture': !exists(json, 'emulate_capture') ? undefined : json['emulate_capture'],
        'emulatePreopen': !exists(json, 'emulate_preopen') ? undefined : json['emulate_preopen'],
        'emulateNtfsStreams': !exists(json, 'emulate_ntfs_streams') ? undefined : json['emulate_ntfs_streams'],
        'emulateRecycleBin': !exists(json, 'emulate_recycle_bin') ? undefined : json['emulate_recycle_bin'],
        'emulateFruit': !exists(json, 'emulate_fruit') ? undefined : json['emulate_fruit'],
        'smbExtraConfig': !exists(json, 'smb_extra_config') ? undefined : json['smb_extra_config'],
        'afpExtraConfig': !exists(json, 'afp_extra_config') ? undefined : json['afp_extra_config'],
        'recycleBinExclude': !exists(json, 'recycle_bin_exclude') ? undefined : json['recycle_bin_exclude'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'externalMacUrl': !exists(json, 'external_mac_url') ? undefined : json['external_mac_url'],
        'externalWinUrl': !exists(json, 'external_win_url') ? undefined : json['external_win_url'],
        'externalLinuxUrl': !exists(json, 'external_linux_url') ? undefined : json['external_linux_url'],
        'allowSymlinks': !exists(json, 'allow_symlinks') ? undefined : json['allow_symlinks'],
        'rwPermissionPriority': !exists(json, 'rw_permission_priority') ? undefined : json['rw_permission_priority'],
        'template': !exists(json, 'template') ? undefined : json['template'],
    };
}

export function WorkspaceDetailPartialUpdateToJSON(value?: WorkspaceDetailPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'production': ProductionReferenceToJSON(value.production),
        'volume': VolumeReferenceToJSON(value.volume),
        'sharing_nfs_permissions': value.sharingNfsPermissions === undefined ? undefined : ((value.sharingNfsPermissions as Array<any>).map(NFSPermissionToJSON)),
        'quota_size_hard': value.quotaSizeHard,
        'quota_size_soft': value.quotaSizeSoft,
        'name': value.name,
        'description': value.description,
        'long_description': value.longDescription,
        'is_template': value.isTemplate,
        'active': value.active,
        'mac_protocol': value.macProtocol,
        'win_protocol': value.winProtocol,
        'win_drive': value.winDrive,
        'linux_protocol': value.linuxProtocol,
        'linux_mountpoint': value.linuxMountpoint,
        'share_name': value.shareName,
        'share_nfs': value.shareNfs,
        'share_afp': value.shareAfp,
        'sharing_hidden': value.sharingHidden,
        'sharing_require_login': value.sharingRequireLogin,
        'sharing_read_only': value.sharingReadOnly,
        'sharing_allow_execute': value.sharingAllowExecute,
        'enable_quota': value.enableQuota,
        'affinity': value.affinity,
        'emulate_avid': value.emulateAvid,
        'emulate_capture': value.emulateCapture,
        'emulate_preopen': value.emulatePreopen,
        'emulate_ntfs_streams': value.emulateNtfsStreams,
        'emulate_recycle_bin': value.emulateRecycleBin,
        'emulate_fruit': value.emulateFruit,
        'smb_extra_config': value.smbExtraConfig,
        'afp_extra_config': value.afpExtraConfig,
        'recycle_bin_exclude': value.recycleBinExclude,
        'is_external': value.isExternal,
        'external_mac_url': value.externalMacUrl,
        'external_win_url': value.externalWinUrl,
        'external_linux_url': value.externalLinuxUrl,
        'allow_symlinks': value.allowSymlinks,
        'rw_permission_priority': value.rwPermissionPriority,
        'template': value.template,
    };
}


